export const stats = {
  table: {
    field: {
      campaign: 'Кампания',
      campaign_id: 'ID Кампании',
      task_number: 'Номер в задаче',
      task_id: 'ID задачи',
      src: 'Caller ID',
      dst: 'Номер',
      call_date: 'Начало звонка',
      progress_date: 'Инициализация звонка',
      answer_date: 'Ответ на звонок',
      connection_date: 'Соединение с оператором',
      end_date: 'Завершение звонка',
      date_time: 'Дата и Время',
      pdd: 'Длительность задержки после набора номера',
      queue_time: 'Длительность ожидания ответа оператора',
      hangup_cause: 'Hangup Cause Code',
      recording: 'Запись разговора',
      duration: 'Длительность звонка',
      cost: 'Стоимость',
      status: 'Статус',
      duration_billed: 'Длительность разговора',
      campaign_name: 'Имя кампании',
      type: 'Тип автоответчика',
      disconnection: 'Произошло отключение',
      amd_result: 'Вероятность'
    }
  },

  filter: {
    status: '@:autocaller_v2.stats.table.field.status',
    task_number: '@:autocaller_v2.stats.table.field.task_number',
    src: '@:autocaller_v2.stats.table.field.src',
    dst: '@:autocaller_v2.stats.table.field.dst',
    campaign_name: '@:autocaller_v2.stats.table.field.campaign_name'
  },

  state: {
    ANSWERED: 'Отвеченный',
    NO_ANSWER: 'Неотвеченный',
    REJECTED: 'Отклоненный',
    ERROR: 'Ошибка'
  }
};
